import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../styles/variablesCss';

const Pagina404 = ({ navigation }) => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {/* Icono de error */}
        <View style={styles.iconContainer}>
          <MaterialCommunityIcons 
            name="alert-circle-outline" 
            size={120} 
            color={colores.rojo} 
          />
        </View>

        {/* Título principal */}
        <Text style={styles.errorCode}>404</Text>
        <Text style={styles.title}>Página No Encontrada</Text>

        {/* Descripción */}
        <Text style={styles.description}>
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </Text>

        {/* Botón de volver */}
        <TouchableOpacity 
          style={styles.button}
          onPress={() => navigation.navigate('Home')}
          activeOpacity={0.8}
        >
          <MaterialCommunityIcons 
            name="home" 
            size={20} 
            color={colores.blanco}
            style={styles.buttonIcon}
          />
          <Text style={styles.buttonText}>Volver al Inicio</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    paddingHorizontal: 20,
  },
  content: {
    alignItems: 'center',
    maxWidth: 500,
    width: '100%',
  },
  iconContainer: {
    marginBottom: 30,
    opacity: 0.9,
  },
  errorCode: {
    fontSize: 80,
    fontFamily: fuentes.bold,
    color: colores.rojo,
    marginBottom: 10,
    lineHeight: 80,
  },
  title: {
    fontSize: 32,
    fontFamily: fuentes.bold,
    color: '#333',
    marginBottom: 15,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    fontFamily: fuentes.regular,
    color: '#666',
    textAlign: 'center',
    marginBottom: 40,
    lineHeight: 24,
  },
  button: {
    backgroundColor: colores.rojo,
    paddingVertical: 14,
    paddingHorizontal: 40,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
    width: '100%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  buttonIcon: {
    marginRight: 10,
  },
  buttonText: {
    color: colores.blanco,
    fontSize: 16,
    fontFamily: fuentes.bold,
  },
  secondaryButton: {
    paddingVertical: 12,
    paddingHorizontal: 30,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: colores.rojo,
  },
  secondaryButtonText: {
    color: colores.rojo,
    fontSize: 14,
    fontFamily: fuentes.semiBold,
  },
});

export default Pagina404;